export default __webpack_public_path__ + "static/media/2nd-blog.deab502c.jpg";